import { PreSCNFicMeeting } from "../../../../../../src/api/preSCNFic";
import { createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit";
import { fetchPreSCNFicMeetings, savePreSCNFicMeetings } from "./PreSCNFicThunk";
import { RootState } from "../../../../../../src/app/store";


const meetingEntityAdapter = createEntityAdapter<
  PreSCNFicMeeting,
  string
>({
  selectId: (meeting) => meeting.meeting_id,
});

interface PreSCNFicState {
  meetings: EntityState<PreSCNFicMeeting, string>;
  fetchStatus: "idle" | "loading" | "succeeded" | "failed";
  fetchError: string | null;
}

const initialState: PreSCNFicState = {
  meetings: meetingEntityAdapter.getInitialState(),
  fetchStatus: "idle",
  fetchError: null,
};

const preSCNFicSlice = createSlice({
  name: "preSCNFic",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPreSCNFicMeetings.pending, (state) => {
      meetingEntityAdapter.removeAll(state.meetings);
      state.fetchStatus = "loading";
      state.fetchError = null;
    });

    builder.addCase(fetchPreSCNFicMeetings.fulfilled, (state, action) => {
      meetingEntityAdapter.setAll(
        state.meetings,
        action.payload.meetings
      );
      state.fetchStatus = "succeeded";
      state.fetchError = null;
    });

    builder.addCase(fetchPreSCNFicMeetings.rejected, (state, action) => {
      state.fetchStatus = "failed";
      state.fetchError = action.payload ?? "Something went wrong";
    });

    builder.addCase(savePreSCNFicMeetings.fulfilled, (state, action) => {
      meetingEntityAdapter.upsertMany(
          state.meetings,
          action.payload.meetings
      );

      const updateRequests = action.meta.arg.payload.update_requests;

      if (updateRequests?.length) {
        updateRequests.forEach((update) => {
          meetingEntityAdapter.updateOne(state.meetings, {
            id: update.meeting_id,
            changes: {
              name_of_committee: update.name_of_committee,
              members_of_committee: update.members_of_committee,
              remarks: update.remarks,
            },
          });
        });
      }    
    });

  },
});

const meetingSelectors =
  meetingEntityAdapter.getSelectors<RootState>(
    (state) => state.preSCNFic.meetings
  );

export const getAllPreSCNFicMeetings =
  meetingSelectors.selectAll;

export const getPreSCNFicMeetingById =
  meetingSelectors.selectById;

export const getPreSCNFicFetchStatus = (
  state: RootState
) => state.preSCNFic.fetchStatus;

export const getPreSCNFicFetchError = (
  state: RootState
) => state.preSCNFic.fetchError;  

export const preSCNFicreducer = preSCNFicSlice.reducer
